import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CheckApiRequests from "./CheckApiRequests";
import PrivateRoute from './components/common/privateRoute/PrivateRoute';
import DefaultLayout from './layouts/DefaultLayout';
import ADashboard from './pages/announcements/dashboard';
import AMessage from './pages/announcements/editor';
import AIndex from './pages/announcements/summary';
import Dashboard from './pages/dashboard/Dashboard';
import Index from "./pages/editors/index";
import Login from './pages/login/Login';
import Logout from './pages/logout/Logout';

const App = props => (
  <CheckApiRequests>
    <BrowserRouter>
      <Switch>
        <Route path="/login" exact
          component={() => Login(props)} />
        <Route path="/logout" exact
          component={() => Logout(props)} />
        <PrivateRoute path="/roads"
          component={() => Index(props)} exact />
        <PrivateRoute path="/announcements" exact
          component={() => ADashboard(props)} />
        <PrivateRoute path="/announcements/:groupType" exact
          component={() => AIndex(props)} />
        <PrivateRoute path="/announcements/:groupType/:actionType" exact
          component={() => AMessage(props)} />
        <Route path="/" exact
          component={() => <DefaultLayout><Dashboard ></Dashboard></DefaultLayout>} />
      </Switch>
    </BrowserRouter>
  </CheckApiRequests>
);

export default App;
